import type { Size } from "@/shared/components/generic/UiEnums.ts";
import { type ReactNode, useState } from "react";
import ScheduleImportDialogOpener from "@/pages/human-resources/time-management/components/schedule-import/ScheduleImportDialogOpener.tsx";
import ScheduleImportMonthDialog from "@/pages/human-resources/time-management/schedules/site-schedule/month-view/import-dialog/ScheduleImportMonthDialog.tsx";
import { useTranslation } from "react-i18next";

interface Properties {
  disabled: boolean;
  buttonSize: Size;
}

export default function ScheduleImportMonthOpener(
  props: Properties,
): ReactNode {
  const { t } = useTranslation("humanResources");
  const [popupOpen, setPopupOpen] = useState(false);
  return (
    <>
      <ScheduleImportDialogOpener
        tooltipLabel={t("timeManagement.scheduleImportDialog.month.title")}
        disabled={props.disabled}
        buttonSize={props.buttonSize}
        onClick={() => {
          setPopupOpen(true);
        }}
      />
      {popupOpen && (
        <ScheduleImportMonthDialog
          onClose={() => {
            setPopupOpen(false);
          }}
        />
      )}
    </>
  );
}
